import { cn } from "@/ui/lib";
import { FC } from "react";
import {
  BUTTON_DEFAULTS,
  BUTTON_WIDTH_CLASS_MAP,
  TButtonSkeletonProps,
} from "../Button.config";

export const ButtonSkeleton: FC<TButtonSkeletonProps> = ({
  width = BUTTON_DEFAULTS.width,
},
) => (
  <div data-component="ButtonSkeleton" className={cn(
    "rounded-sys-full h-9 min-w-32 bg-state-loading",
    BUTTON_WIDTH_CLASS_MAP[width],
  )}></div>
);
